import { useState, useEffect } from 'react';
import { dbService } from '../../fbase';

import { Table, Accordion } from 'react-bootstrap';
import Loading from '../../components/Loading';

function Board() {
  const [notifications, setNotifications] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    dbService.collection('notifications').onSnapshot((snapshot) => {
      const notifs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      notifs.sort((a, b) => b.number - a.number);
      console.log(notifs);
      setNotifications(notifs);
    });
    setLoad(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {load ? (
        <Loading />
      ) : (
        <div className="board__container">
          <div className="board__wrapper">
            <Table className="board__table" hover size="sm">
              <thead className="board__table-thead">
                <tr className="board__table-tr">
                  <th className="board__table-th board__table-index"></th>
                  <th className="board__table-th board__table-title">제목</th>
                  <th className="board__table-th board__table-date">날짜</th>
                </tr>
              </thead>
              {notifications.length > 0 && (
                <Accordion as={'tbody'} className="board__table-tbody">
                  {notifications?.map((notif, index) => (
                    <>
                      <Accordion.Toggle
                        as={'tr'}
                        key={notif.id}
                        className="board__table-tr table-click"
                        variant="link"
                        eventKey={notif.id}
                      >
                        <td className="board__table-td board__table-index">
                          {notifications.length - index}
                        </td>
                        <td className="board__table-td board__table-title">
                          {notif.title}
                        </td>
                        <td className="board__table-td board__table-date">
                          {notif.date}
                        </td>
                      </Accordion.Toggle>
                      <tr>
                        <td colSpan="3" className="board__table-tr">
                          <Accordion.Collapse eventKey={notif.id}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: notif.message,
                              }}
                              className="board__table-collapse column"
                            ></div>
                          </Accordion.Collapse>
                        </td>
                      </tr>
                    </>
                  ))}
                </Accordion>
              )}
            </Table>
          </div>
        </div>
      )}
    </>
  );
}
export default Board;
